// extracted by mini-css-extract-plugin
export var aiStarIcon = "_af-4";
export var closeButton = "_af-6";
export var dismissButton = "_af-3";
export var editImageWithAiContainer = "_af-8";
export var imageUploadWrapper = "_af-7";
export var misspelledWord = "_af-5";
export var spellCheckContainer = "_af-2";
export var spin = "_af-1";
export var spinning = "_af-0";